import * as React from "react"
const Checklist = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3.545}
      d="m7.818 22 10.637 10.636 17.727-21.273"
    />
  </svg>
)
export default Checklist